import { useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { Home, Phone, Sparkles } from "lucide-react";
import { PHONE, PHONE_LINK, FONT_HEAD, FONT_BODY, NAVY, GOLD, isSpanishPath } from "../lib/constants";

const COPY = {
  en: { code: "404", title: "Page not found", text: "The page you're looking for doesn't exist or has moved.", home: "Back to home", homeTo: "/", services: "View our services", servicesTo: "/services" },
  es: { code: "404", title: "Página no encontrada", text: "La página que buscas no existe o fue movida.", home: "Volver al inicio", homeTo: "/es", services: "Ver nuestros servicios", servicesTo: "/es#servicios" },
};

const useNoIndex = (title) => {
  useEffect(() => {
    document.title = title;
    const meta = document.querySelector('meta[name="robots"]');
    const previous = meta?.getAttribute("content");
    meta?.setAttribute("content", "noindex, follow");
    return () => previous && meta?.setAttribute("content", previous);
  }, [title]);
};

export default function NotFoundPage() {
  const { pathname } = useLocation();
  const c = isSpanishPath(pathname) ? COPY.es : COPY.en;
  useNoIndex(`${c.title} | Cindyrella Cleaning LLC`);
  return (
    <section data-testid="not-found-page" className="pt-36 pb-24 min-h-[70vh] flex items-center" style={{ background: "#F9FAFB" }}>
      <div className="max-w-2xl mx-auto px-4 md:px-8 text-center">
        <p className="text-6xl font-extrabold mb-4" style={{ fontFamily: FONT_HEAD, color: GOLD }}>{c.code}</p>
        <h1 className="text-4xl sm:text-5xl font-bold mb-4" style={{ fontFamily: FONT_HEAD, color: NAVY }} data-testid="not-found-title">{c.title}</h1>
        <p className="text-base md:text-lg mb-8" style={{ color: "#6B7280", fontFamily: FONT_BODY }}>{c.text}</p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Link to={c.homeTo} data-testid="not-found-home-link" className="inline-flex items-center justify-center gap-2 px-7 py-4 text-base font-bold transition-all hover:opacity-90" style={{ background: NAVY, color: "#FFFFFF", fontFamily: FONT_BODY }}>
            <Home size={18} /> {c.home}
          </Link>
          <Link to={c.servicesTo} data-testid="not-found-services-link" className="inline-flex items-center justify-center gap-2 px-7 py-4 text-base font-bold border-2 transition-all hover:bg-[#1B3A6B] hover:text-white" style={{ borderColor: NAVY, color: NAVY, fontFamily: FONT_BODY }}>
            <Sparkles size={18} /> {c.services}
          </Link>
        </div>
        <a href={PHONE_LINK} data-testid="not-found-call-link" className="inline-flex items-center gap-2 mt-8 text-sm font-bold" style={{ color: NAVY, fontFamily: FONT_BODY }}>
          <Phone size={16} style={{ color: GOLD }} /> {PHONE}
        </a>
      </div>
    </section>
  );
}
